import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
let Collocation = class Collocation extends Vue {
    constructor() {
        super(...arguments);
        this.backgroundGrayFlag = false;
        this.progress = {
            width: 0,
            left: 0,
        };
    }
    get progressStyle() {
        return {
            width: `${this.progress.width * 100}%`,
            left: `${100 * this.progress.left}%`,
        };
    }
    get isDiscount() {
        return this.collocationInfo.preferential_type === 'discount';
    }
    get goodsList() {
        return this.maxGoods
            ? this.collocationInfo.goodsList.slice(0, this.maxGoods)
            : this.collocationInfo.goodsList;
    }
    get isVipgoods() {
        return (this.goodsList || []).filter(el => el.vip_price).length;
    }
    get mato40() {
        // console.log('我是啦啦啦啦啦',this.$route)
        if (!this.$route.query['f_r_o_m']) {
            return true;
        }
        else {
            return false;
        }
    }
    created() {
        console.log(this.backgroundGray);
        if (this.backgroundGray === '详情页') {
            this.backgroundGrayFlag = true;
        }
    }
    mounted() {
        this.scrollListen();
    }
    toCollocationList() {
        this.$emit('toCollocationList');
    }
    toDetail() {
        this.$emit('toDetail', this.collocationInfo.id);
    }
    scrollListen() {
        if (!this.showProgress)
            return;
        let l = this.goodsList.length;
        this.progress = {
            width: 3 / l,
            left: 0,
        };
        if (l > 3) {
            let goods = this.$refs['collocation-goods'];
            goods.addEventListener('scroll', this.scrollFn);
        }
    }
    scrollFn(e) {
        let { scrollLeft: s, offsetWidth: w, scrollWidth: tw } = e.target;
        this.progress = {
            width: Math.min(w / tw, 1),
            left: Math.min(s / tw, 1),
        };
    }
    beforeDestory() {
        let goods = this.$refs['collocation-goods'];
        goods.removeEventListener('scroll', this.scrollFn);
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], Collocation.prototype, "collocationInfo", void 0);
tslib_1.__decorate([
    Prop()
], Collocation.prototype, "curSkuId", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], Collocation.prototype, "showProgress", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], Collocation.prototype, "aloneTitle", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], Collocation.prototype, "showMore", void 0);
tslib_1.__decorate([
    Prop()
], Collocation.prototype, "maxGoods", void 0);
tslib_1.__decorate([
    Prop()
], Collocation.prototype, "backgroundGray", void 0);
Collocation = tslib_1.__decorate([
    Component({})
], Collocation);
export default Collocation;
